import React from 'react';

export const Hammer = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="20"
      height="20"
      transform="translate(0.23584 0.881836)"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      d="M2.39891 9.1317L3.02491 8.49347C3.1978 8.31721 3.47802 8.31721 3.65091 8.49347L3.96377 8.81244L4.7632 7.99739C4.60746 7.3964 4.75325 6.7311 5.21548 6.25984L6.46719 4.98368C8.19553 3.22159 10.998 3.22159 12.7266 4.98368L10.2229 6.25984V6.78864C10.2229 7.26723 10.0364 7.72637 9.70423 8.0648L8.3449 9.45067C7.88267 9.92193 7.23012 10.0706 6.64064 9.91178L5.8412 10.7268L6.15406 11.0458C6.32695 11.2221 6.32695 11.5078 6.15406 11.684L5.52806 12.3222C5.35517 12.4985 5.07496 12.4985 4.90207 12.3222L2.39836 9.76964C2.22602 9.59365 2.22603 9.30796 2.39891 9.1317ZM10.3302 8.70302C10.4326 8.59867 10.5194 8.48332 10.6027 8.366L17.6593 15.083C18.3666 15.7565 18.3857 16.8933 17.7016 17.591C17.0176 18.2888 15.9022 18.2693 15.2416 17.5479L8.65444 10.3543C8.76399 10.2722 8.87298 10.1887 8.9709 10.0889L10.3302 8.70302Z"
      fill={color || '#FF5630'}
    />
  </svg>
);
